import { safeLocalStorage } from './safeStorage';

export const ORDER_FEEDBACK_LAST_SHOWN_AT_KEY = 'hzc_feedback_flow_last_shown_at';
export const ORDER_FEEDBACK_LIFETIME_COUNT_KEY = 'hzc_feedback_flow_lifetime_count';

export function clearOrderFeedbackFlowStorage() {
  if (typeof window === 'undefined') return;
  safeLocalStorage.removeItem(ORDER_FEEDBACK_LAST_SHOWN_AT_KEY);
  safeLocalStorage.removeItem(ORDER_FEEDBACK_LIFETIME_COUNT_KEY);
}
